import { IsNotEmpty, IsString, IsUUID } from 'class-validator';

export class GetUserPhotoDto {
  @IsUUID()
  @IsString()
  @IsNotEmpty()
  user_id: string;
}
